import {
	Facebook,
	Instagram,
	Tiktok
} from 'assets/landing';

const navLinks = [
	{ path: '/', label: 'Home' },
	{ path: '/menu', label: 'Menu' },
	{ path: '/reservations', label: 'Reservations' },
	{ path: '/contact', label: 'Contact' },
	{ path: '/cafe-speak', label: 'Cafe Speak' }
];

const informativeLinks = [
	{ path: '/partners', label: 'Partners' },
	{ path: '/legal', label: 'Legal' },
	{ path: '/about', label: 'About' },
	{ path: '/careers', label: 'Careers' }
];

const socialLinks = [
	{ path: 'https://www.instagram.com/speakeasy.pk', Icon: Instagram, label: 'instagram' },
	// { path: 'https://www.x.com', Icon: X, label: 'X' },
	// { path: 'https://www.youtube.com', Icon: Youtube, label: 'youtube' },
	{ path: 'https://www.facebook.com/speakeasy.pk', Icon: Facebook, label: 'facebook' },
	{ path: 'https://www.tiktok.com/@speakeasy.pk', Icon: Tiktok, label: 'tiktok' }
];

export {
	navLinks,
	informativeLinks,
	socialLinks
};
